<template>
  <el-dialog
    title="申请入驻"
    :visible.sync="dialogVisible"
    width="80%"
    @close="handleClose"
  >
    <p style="color: red;">{{errorInfo}}</p>
    <el-row :gutter="20">
      <el-col :span="24">
        <el-card header="flex justify-between">
          <el-row :gutter="20">
            <el-col :span="18"></el-col>
            <el-col :span="6">
              <el-input-group>
                <el-input
                  v-model="searchCommunityName"
                  placeholder="输入小区名称"
                  size="small"
                ></el-input>
                <el-button
                  slot="append"
                  type="primary"
                  size="small"
                  @click="listNoEnterCommunity"
                >查询</el-button>
              </el-input-group>
            </el-col>
          </el-row>

          <el-table
            :data="communityInfo"
            style="width: 100%; margin-top: 15px"
            border
            stripe
          >
            <el-table-column prop="communityId" label="小区ID"></el-table-column>
            <el-table-column prop="name" label="名称"></el-table-column>
            <el-table-column prop="address" label="地址"></el-table-column>
            <el-table-column label="操作" align="right">
              <template slot-scope="scope">
                <el-button
                  size="mini"
                  @click="_saveEnterCommunity(scope.row)"
                >申请入驻</el-button>
              </template>
            </el-table-column>
          </el-table>
        </el-card>
      </el-col>
    </el-row>
  </el-dialog>
</template>

<script>
import { listNoEnterCommunity, saveEnterCommunity } from '@/api/common/enterCommunity/enterCommunityApi'

export default {
  name: 'StoreEnterCommunity',
  data() {
    return {
      dialogVisible: false,
      communityInfo: [],
      errorInfo: '',
      searchCommunityName: ''
    }
  },
  methods: {
    open() {
      this.dialogVisible = true
      this.searchCommunityName = ''
      this.listNoEnterCommunity()
    },
    handleClose() {
      this.dialogVisible = false
      this.errorInfo = ''
    },
    async listNoEnterCommunity() {
      try {
        const res = await listNoEnterCommunity({
          communityName: this.searchCommunityName
        })
        this.communityInfo = res
      } catch (error) {
        console.error('查询未入驻小区失败:', error)
      }
    },
    async _saveEnterCommunity(communityInfo) {
      try {
        await saveEnterCommunity({
          communityId: communityInfo.communityId
        })
        this.$emit('refresh')
        this.dialogVisible = false
      } catch (error) {
        this.errorInfo = error.message || '申请入驻失败'
        console.error('申请入驻失败:', error)
      }
    }
  }
}
</script>